import classNames from "classnames/bind";
import styles from './TablePlate.module.css';
import { ImageObject, Table } from "../../../../../../components";
import { useContext, useEffect } from "react";
import { LisencePlateContext } from "../../../../../../contexts";
import { formatDateToTime } from "../../../../../../utils";

const cx = classNames.bind(styles);

const TablePlate = ({ data, nameCamera }) => {
    const { screen, info, setShowInfo, showInfo, setInfo } = useContext(LisencePlateContext)
    // const list = data ? data?.filter((item, index) => index <= 100).map((item, index) => {
    const list = data ? data?.map((item, index) => {
        return {
            image: <ImageObject src={`${item?.path}`} />,
            time: item?.time ? formatDateToTime(item?.time) : '',
            name: item?.object_name || '',
            object_id: item?.object_id || '',
            nameCamera: nameCamera,
            path: item?.path || ''
        }
    }) : []
    const col = [
        {
            label: "Ảnh",
            key: "image",
            align: 'center'
        },
        {
            label: "Tên nhân viên",
            key: "name",
            align: 'left'
        },
        {
            label: "Thời gian",
            key: "time",
            align: 'right'
        },
    ]

    useEffect(() => {
        if (data?.length === 1 || data?.length === 20) {
            setInfo({ ...data[0], nameCamera: nameCamera })
            setShowInfo(true)
        }
    }, [data, nameCamera])
    return (
        <div className={cx('container')}>
            <div className={cx('table', screen.total === 2 ? 'small-height' : '')}>
                <Table colum={col} data={list} onClick={(item) => {
                    setInfo(item)
                    setShowInfo(true)
                }}
                    className={cx('table-ct')}
                />
            </div>
        </div>
    )
}

export default TablePlate